import type { Component } from "solid-js";

/**
 * A brand mark drawn in the current text colour, masked from a single-colour SVG,
 * so one asset follows both themes. Decorative unless given a `label`.
 */
export const BrandGlyph: Component<{ src: string; class?: string; label?: string }> = (props) => (
  <span
    role={props.label ? "img" : undefined}
    aria-label={props.label}
    aria-hidden={props.label ? undefined : "true"}
    class={`inline-block shrink-0 bg-current ${props.class ?? "size-4"}`}
    style={{
      "-webkit-mask": `url(${props.src}) center / contain no-repeat`,
      mask: `url(${props.src}) center / contain no-repeat`,
    }}
  />
);
